import React from 'react';

import { AgentDetails } from '../Components/index';

const Me = () => <AgentDetails header="My Overview" id={'me'} />;

export default Me;
